const AnnouncementBanner = () => {
  return (
    <div className="w-full bg-primary py-2 px-4">
      <a
        href="https://apps.apple.com/app/qwip/id6761749249"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-3 text-sm text-primary-foreground/90 hover:text-primary-foreground transition-colors text-center"
        aria-label="Download qwip on the App Store"
      >
        <span className="w-2 h-2 rounded-full bg-white/60 animate-pulse flex-shrink-0 hidden tablet:inline-block" />
        <span>
          looking for remote work spots in london? download our app
        </span>
        <img
          src="/badges/app-store-badge.svg"
          alt="Download on the App Store"
          className="h-7 w-auto"
        />
      </a>
    </div>
  );
};

export default AnnouncementBanner;
